module.exports = __webpack_public_path__ + "static/media/subOutlook2.2563f7b7.png";